/* eslint-disable no-new */

import Vue from 'vue'

import App from './App'
import router from './router/index'
import store from './store/index'

import Tooltip from 'vue-directive-tooltip'
import ru from 'vee-validate/dist/locale/ru'
import VeeValidate, {Validator} from 'vee-validate'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import Nav from '@/components/layout/Nav.vue'
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import Search from '@/components/search/Search.vue'
import Admin from '@/pages/admin/Admin.vue'
import Loader from '@/components/Loader'
import Pagination from '@/components/Pagination'

require('./utils/fontawesome.js')
require('./utils/filters.js')

Vue.config.productionTip = false

Vue.component('app-nav', Nav)
Vue.component('app-header', Header)
Vue.component('app-footer', Footer)
Vue.component('app-search', Search)
Vue.component('app-admin', Admin)
Vue.component('loader', Loader)
Vue.component('pagination', Pagination)

Vue.use(Tooltip)
Validator.localize('ru', ru)

// только ручная валидация
Vue.use(VeeValidate, {events: ''})

Vue.component('v-select', vSelect)

new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js